import { useEffect, useState } from "react";
import axios from "axios";
import { ShieldAlert, ShieldCheck, ShieldQuestion } from "lucide-react";
import { API, money } from "./shared";

export default function RiskScoreCard({ customerId }) {
  const [d, setD] = useState(null), [open, setOpen] = useState(false);
  useEffect(() => { axios.get(`${API}/finance/risk/${customerId}`).then(r => setD(r.data)).catch(() => setD(null)); }, [customerId]);
  if (!d) return null;
  const I = d.level === "low" ? ShieldCheck : d.level ? ShieldAlert : ShieldQuestion;
  const s = d.stats;
  return <div className={`risk-card risk-${d.level || "none"}`} data-testid="risk-score-card">
    <button type="button" className="risk-head" data-testid="risk-toggle" onClick={() => setOpen(o => !o)}>
      <I size={22} />
      <div className="risk-score"><b data-testid="risk-score-value">{d.score ?? "—"}</b><small>/100</small></div>
      <div className="risk-title"><span>RİSK SKORU · TÜM GEÇMİŞ</span><strong data-testid="risk-level">{d.level_label}</strong></div>
      <div className="risk-stats">
        <span>Ort. ödeme <b>{s.avg_pay_days != null ? `${s.avg_pay_days} gün` : "—"}</b></span>
        <span>En eski borç <b>{s.oldest_open_days ? `${s.oldest_open_days} gün` : "—"}</b></span>
        <span>Karşılıksız <b>{s.bounced_count}</b></span>
        <span>Portföyde çek <b>{money(s.pending_checks)}</b></span>
      </div>
      <em className="risk-more">{open ? "Gizle" : "Detay"}</em>
    </button>
    {open && <div className="risk-factors" data-testid="risk-factors">
      {d.factors.length ? d.factors.map(f => <div key={f.label} className="risk-factor"><span>{f.label}</span><em>{f.value}</em><b className={f.impact < 0 ? "danger-text" : f.impact > 0 ? "good-text" : "muted"}>{f.impact > 0 ? "+" : ""}{f.impact}</b></div>) : <p className="muted">Skor için yeterli hareket yok.</p>}
      <p className="muted risk-note">Toplam borç {money(s.total_debit)} · Toplam ödeme {money(s.total_credit)} · Aylık ort. alım {money(s.monthly_avg)}</p>
    </div>}
  </div>;
}
